import { render, staticRenderFns } from "./InsCmsCat5.vue?vue&type=template&id=51f1c3e6&scoped=true&"
import script from "./InsCmsCat5.vue?vue&type=script&lang=ts&"
export * from "./InsCmsCat5.vue?vue&type=script&lang=ts&"
import style0 from "./InsCmsCat5.vue?vue&type=style&index=0&id=51f1c3e6&lang=less&scoped=true&"
import style1 from "./InsCmsCat5.vue?vue&type=style&index=1&id=51f1c3e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f1c3e6",
  null
  
)

export default component.exports